import * as React from "react";
import FormTypeSidebar from "./FormTypeSidebar";
class FormTypesHome extends React.Component {
  constructor() {
    super();
    this.state = {};
  }
  componentDidMount() {
  }
  componentWillUnmount() {
  }
  componentDidUpdate() {
  }
  render() {
    return /* @__PURE__ */ React.createElement("div", { className: "sidebarLayout d-flex flex-row flex-fill" }, /* @__PURE__ */ React.createElement("div", { className: "sidebar-container" }, /* @__PURE__ */ React.createElement(FormTypeSidebar, null)), /* @__PURE__ */ React.createElement("div", { className: "flex-fill" }, /* @__PURE__ */ React.createElement("div", { className: "h-100 d-flex flex-column align-items-center justify-content-center" }, /* @__PURE__ */ React.createElement("i", { className: "fa-duotone fa-regular fa-file-lines fa-5x" }), /* @__PURE__ */ React.createElement(
      "h2",
      {
        style: {
          fontWeight: "bolder",
          fontStyle: "italic",
          margin: "16px"
        }
      },
      "Form Types"
    ))));
  }
}
export default FormTypesHome;
